import MemberDetailsServices from './MemberDetailsServices';
import MemberDetailsServicesMock from './MemberDetailsServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? MemberDetailsServicesMock : MemberDetailsServices;
